import React from 'react';
import {injectIntl} from 'react-intl';

const Block = ({intl, title, description, children, blockSmall = false, noIntl = false}) => {
  return (
    <div className={`block ${blockSmall ? 'block--s' : ''}`}>
      <div className="block__wrapper wrapper">
        <div className="block__header">
          <h2 className="block__title">
            {noIntl ? title : intl.formatMessage({id: title})}
          </h2>
          {description &&
            <div className="mt-s">
              {noIntl ? description : intl.formatMessage({id: description})}
            </div>
          }
        </div>
        <div className="block__content">
          {children}
        </div>
      </div>
    </div>
  );
};

export default injectIntl(Block);
